<template>
  <div>
    <b-row>
      <b-col md="12" >
        <b-card>
          <b-row class="mb-2">
            <!-- Per Page -->
            <b-col cols="12" md="3" class="d-flex align-items-center justify-content-start mb-md-0">
              <label for="example-datepicker">Desde</label>&nbsp;
              <b-form-datepicker id="beginDate" placeholder="" v-model="beginDate" class="mb-2"></b-form-datepicker>
            </b-col>
            <b-col cols="12" md="3" class="d-flex align-items-center justify-content-start mb-md-0">
              <label for="example-datepicker">Hasta</label>&nbsp;
              <b-form-datepicker id="finishDate" placeholder="" v-model="finishDate" class="mb-2"></b-form-datepicker>
            </b-col>
            <b-col cols="12" md="3" class="d-flex align-items-center justify-content-start mb-2">
              <b-button variant="primary" @click="getDashboard">
                <feather-icon icon="SearchIcon" class="mr-50"/>
                <span>Buscar</span>
              </b-button>
            </b-col>
          </b-row>
          <div class="text-left"><b>{{$t('Labels.TotalServices')}}</b></div>
          <vue-apex-charts
            v-if="stadisticsChart.ready"
            type="bar"
            height="350"
            :options="stadisticsChart.chartOptions"
            :series="stadisticsChart.series"
          />
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12" >
        <b-card>
          <div class="text-left"><b>{{$t('Labels.ServicesByDay')}}</b></div>
          <vue-apex-charts
            v-if="stadisticsByDayChart.ready"
            type="bar"
            height="350"
            :options="stadisticsByDayChart.chartOptions"
            :series="stadisticsByDayChart.series"
          />
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import {
  BCard, BRow, BCol, BButton, BFormDatepicker
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import request from '@/libs/request/index'
import { timeZoneDate } from '@/libs/tools/helpers'

export default {
  components: {
    BCard,
    VueApexCharts,
    BRow,
    BCol,
    BButton,
    BFormDatepicker
  },
  data () {
    return {
      stadisticsChart: {
        ready: false,
        series: [
          {
            name: '',
            data: []
          }
        ],
        chartOptions: {
          chart: {
            type: 'bar',
            height: 350,
            toolbar: {
              show: false
            }
          },
          plotOptions: {
            bar: {
              columnWidth: '20%',
              // borderRadius: 15,
              horizontal: false
            }
          },
          dataLabels: {
            enabled: false
          },
          legend: {
            show: true,
            position: 'top',
            fontSize: '14px',
            fontFamily: 'Montserrat',
            horizontalAlign: 'left'
          },
          stroke: {
            show: true,
            colors: ['transparent']
          },
          grid: {
            xaxis: {
              lines: {
                show: true
              }
            }
          },
          xaxis: {
            categories: [],
            title: {
              text: `${this.$t('Labels.Type')} ${this.$t('Labels.Services')}`
            }
          },
          yaxis: {
            title: {
              text: `${this.$t('Labels.Cuantity')}`
            },
            labels: {
              formatter: function (val) {
                return val.toFixed(0)
              }
            }
          },
          fill: {
            opacity: 1
          }
        }
      },
      stadisticsByDayChart: {
        ready: false,
        series: [
          {
            name: `${this.$t('Labels.NoEnergized')}`,
            data: [],
            color: ['#9696DE']
          },
          {
            name: `${this.$t('Labels.Services')}`,
            data: [],
            color: ['#7467F0']
          }
        ],
        chartOptions: {
          chart: {
            type: 'bar',
            height: 350,
            toolbar: {
              show: false
            }
          },
          plotOptions: {
            bar: {
              // borderRadius: 15,
              columnWidth: '20%',
              horizontal: false
            }
          },
          dataLabels: {
            enabled: false
          },
          legend: {
            show: true,
            position: 'top',
            fontSize: '14px',
            fontFamily: 'Merriweather+Sans',
            horizontalAlign: 'left'
          },
          stroke: {
            show: true,
            colors: ['transparent']
          },
          grid: {
            xaxis: {
              lines: {
                show: true
              }
            }
          },
          xaxis: {
            categories: [],
            title: {
              text: `${this.$t('Labels.Day')}`
            }
          },
          yaxis: {
            title: {
              text: `${this.$t('Labels.Cuantity')}`
            },
            labels: {
              formatter: function (val) {
                return val.toFixed(0)
              }
            }
          },
          fill: {
            opacity: 1
          }
        }
      },
      beginDate: '',
      finishDate: ''
    }
  },
  methods: {
    async getDashboard () {
      this.stadisticsChart.ready = false
      this.stadisticsByDayChart.ready = false
      const params = {
        url: 'panic_button/alerts/estadistics',
        method: 'GET',
        params: {
          begin_date: this.beginDate ? `${this.beginDate} 00:00:00` : '',
          end_date: this.finishDate ? `${this.finishDate} 23:59:59` : '',
          timezone_offset: (new Date().getTimezoneOffset())
        }
      }
      await request(params).then(response => {
        this.stadisticsChart.series[0].data = [
          {
            x: `${this.$t('Labels.Services')}`,
            y: parseInt(response.data.data.alerts),
            fillColor: '#7467F0'
          },
          {
            x: `${this.$t('Labels.NoEnergized')}`,
            y: parseInt(response.data.data.energy),
            fillColor: '#9696DE'
          }
        ]
        this.stadisticsChart.ready = true

        this.stadisticsByDayChart.chartOptions.xaxis.categories = []
        this.stadisticsByDayChart.series[0].data = []
        this.stadisticsByDayChart.series[1].data = []
        response.data.byDays.forEach((element, index) => {
          this.stadisticsByDayChart.chartOptions.xaxis.categories.push(timeZoneDate(`${element.dayCreated} 23:59:59`))
          this.stadisticsByDayChart.series[0].data.push({
            x: `${this.$t('Labels.Services')}`,
            y: parseInt(element.alerts),
            fillColor: '#7467F0'
          })
          this.stadisticsByDayChart.series[1].data.push({
            x: `${this.$t('Labels.NoEnergized')}`,
            y: parseInt(element.energy),
            fillColor: '#9696DE'
          })
        })
        console.log(this.stadisticsByDayChart.chartOptions.xaxis.categories)
        console.log(this.stadisticsByDayChart.series)

        this.stadisticsByDayChart.ready = true
      })
    }
  },
  created () {
    this.getDashboard()
  }
}
</script>
<style lang="scss">
  @import '@core/scss/vue/libs/vue-flatpicker.scss';
  @import '@core/scss/vue/libs/chart-apex.scss';
</style>
